import ReactDOM from 'react-dom/client';
import App from './App';
import { AppAuthProvider } from './logic/ctx/AppAuthCtx';

// Polyfill for crypto.randomUUID if not available (mobile browser compatibility)
if (!crypto.randomUUID) {
    (crypto.randomUUID as any) = function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <AppAuthProvider>
    <App />
  </AppAuthProvider>
);

// Service Worker handling: only register in production. In development, ensure
// any previously registered SWs are unregistered to prevent stale caching that
// interferes with hot reload.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isProd = process.env.NODE_ENV === 'production';

    if (isProd) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // console.log('SW registered: ', registration);

          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('New content available, please refresh.');
                  // Optional: show a toast to refresh
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    } else {
      // Dev mode: aggressively remove any existing SWs and caches
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => {
          if (regs.length) console.log(`[DEV] Unregistering ${regs.length} service worker(s)`);
          return Promise.all(regs.map((r) => r.unregister()));
        })
        .then(() => {
          if ((window as any).caches && typeof caches.keys === 'function') {
            return caches.keys().then((keys) => {
              if (keys.length) console.log(`[DEV] Deleting ${keys.length} cache(s):`, keys);
              return Promise.all(keys.map((k) => caches.delete(k)));
            });
          }
        })
        .catch((err) => console.warn('[DEV] SW/caches cleanup failed:', err));
    }
  });
}